import { render } from "./guide1.vue?vue&type=template&id=0909b22f&ts=true"
import script from "./guide1.vue?vue&type=script&lang=ts"
export * from "./guide1.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__